import { ThemeOptions } from '@mui/material';

export const mixins: ThemeOptions['mixins'] = {
  // TODO: Should this be customized based on dark/light theme?
  visibleScrollbar: {
    // this is to make the scroll bar always visible.
    // it will hide if there is no overflow.
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      border: '2px solid #ffffff00',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    '&::-webkit-scrollbar:horizontal': {
      height: '11px',
    },
    '&::-webkit-scrollbar:vertical': {
      width: '8px',
    },
  },
  toolbar: {
    minHeight: 60,
  },
};
